export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_00.5be67a5e.jpg";